import { connect } from 'react-redux';

import logout from '../../actions/logout';
import NavigationSideMenu from '../../components/navigation/side/Menu';
import { menuGroups } from '../../constants/navigation';
import {
  getEventNames,
  getMyPermissions,
  getTenantId,
  sideMenuCollapsed,
} from '../../reducers/analyticsApp';
import { hasPermissions } from '../../utils/permissions';
import { checkEvents } from '../../utils/event/common';
import { setSideMenuCollapsed } from '../../actions/application';

const createMenuGroup = (permissions, menuGroupsParam, eventNames) =>
  Object.fromEntries(
    Object.entries(menuGroupsParam)
      .map(([title, group]) => [
        title,
        group
          .filter(({ permission: tabPermissions }) => hasPermissions(tabPermissions, permissions))
          .filter(({ events: tabEvents }) => checkEvents(tabEvents, eventNames)),
      ])
      .filter(([, group]) => group.length !== 0)
  );

const mapStateToProps = (state) => ({
  permissions: getMyPermissions(state),
  eventNames: getEventNames(state),
  tenantPath: `/${getTenantId(state)}`,
  sideMenuCollapsed: sideMenuCollapsed(state),
});

const mapDispatchToProps = {
  onLogout: logout,
  setSideMenuCollapsed,
};

const mergeProps = (mapStateToPropsParam, mapDispatchToPropsParam, ownProps) => ({
  ...ownProps,
  ...mapStateToPropsParam,
  ...mapDispatchToPropsParam,
  menuGroups: createMenuGroup(
    mapStateToPropsParam.permissions,
    menuGroups,
    mapStateToPropsParam.eventNames
  ),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(NavigationSideMenu);
